// src/components/Address/helpers.js

export const handleHeadingFocus = (event) => {
  event.target.select();
};

export const handleOutsideClick = (gridRef, setBorder) => (event) => {
  if (gridRef.current && !gridRef.current.contains(event.target)) {
    setBorder(false);
  }
};

/**
 * handleCondition
 * Now properly receives and uses setCondition as a callback.
 */
export const handleCondition = (
  currentPage,
  readOnly,
  dataCondition,
  title,
  setCondition
) => {
  if (currentPage === '/publish') {
    if (readOnly || dataCondition) {
      if (title === "Address") {
        setCondition(true);
      } else {
        setCondition(false);
      }
    } else {
      setCondition(false);
    }
  } else {
    setCondition(false);
  }
};

/**
 * fillInputValue
 * Defensive: ensures drawerData and existingComponentIndex are valid.
 */
export const fillInputValue = (
  drawerData,
  existingComponentIndex,
  addressValue,
  streetInput,
  streetValue,
  streetInputSecond,
  streetValueSecond,
  cityInput,
  city,
  provinceInput,
  province,
  postalInput,
  postal,
  readOnly
) => {
  if (
    drawerData &&
    drawerData.length > 0 &&
    existingComponentIndex !== -1 &&
    drawerData[existingComponentIndex]
  ) {
    const state = drawerData[existingComponentIndex].state;
    state.addressValue = addressValue;
    state.mainStreetInput = streetInput;
    state.streetValue = streetValue;
    state.mainStreetInputSecond = streetInputSecond;
    state.streetValueSecond = streetValueSecond;
    state.mainCityInput = cityInput;
    state.city = city;
    state.mainProvinceInput = provinceInput;
    state.province = province;
    state.mainPostalInput = postalInput;
    state.postal = postal;
    state.readOnly = readOnly;
  }
};
